"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeltdownAbilityHandler = exports.MeltdownActorAbilityFactory = exports.MeltdownAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
class MeltdownAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Meltdown;
        this.__typeName = "Meltdown";
    }
}
exports.MeltdownAbilityArgs = MeltdownAbilityArgs;
let MeltdownActorAbilityFactory = class MeltdownActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Meltdown", "AllEnemies", 4);
    }
};
MeltdownActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Meltdown")
], MeltdownActorAbilityFactory);
exports.MeltdownActorAbilityFactory = MeltdownActorAbilityFactory;
let MeltdownAbilityHandler = class MeltdownAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: (sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                    .forEach(targetId => container.applyProjectiles({
                    sequence,
                    projectiles: [
                        {
                            creatorId: ability.invokerId,
                            targetId,
                            jitter: (0, Random_1.random)(25, 75),
                            path: "line",
                            type: "FireBolt"
                        }
                    ],
                    onProjectile: sequence => {
                        container.applyDebuff({
                            sequence,
                            attackerId: ability.invokerId,
                            targetId,
                            duration: Duration_1.Duration.Turns(1),
                            effect: new core_1.MeltdownEffectArgs(),
                            supernatural: true
                        });
                    }
                }));
            })
        });
    }
};
MeltdownAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Meltdown)
], MeltdownAbilityHandler);
exports.MeltdownAbilityHandler = MeltdownAbilityHandler;
